import {IListItem } from '@nkr/models/index';

export interface ILanguageVariableReportLookupData {
    languageList: IListItem[]
}
